import {
  ResponsiveImage,
  ResponsiveImageProps,
} from '@/components/ResponsiveImage'

export interface ImageModuleProps {
  image: ResponsiveImageProps
}

export const ImageModule: React.FC<ImageModuleProps> = ({ image }) => (
  <ResponsiveImage {...image} />
)
